import * as React from 'react';
import { Fragment } from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { ScheduleRangeStart } from './ScheduleRangeStart';
import { ScheduleRangeEnd } from './ScheduleRangeEnd';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const RawScheduleRange = ({ t, ...props }: OwnProps & TranslateProps) =>
    <Fragment>
        <ScheduleRangeStart { ...props }/>
        <ScheduleRangeEnd { ...props }/>
    </Fragment>
;

export const ScheduleRange = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('ScheduleRange'),
    translate(),
)(RawScheduleRange);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/runOnSchedule/ScheduleRange.tsx